import { CategoryWithDimensionId } from "@/store/dimensions/utils/types/common";

export const isCategoryWithDimensionId = (
  category: any,
): category is CategoryWithDimensionId => {
  return !!category.dimensionId;
};
